// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as Utils_String$LiveRoom from "../../Utils/Utils_String.bs.js";
import * as SterlingModal$LiveRoom from "../../bindings/SterlingModal.bs.js";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";
import * as AuctionRoomSharedContacts$LiveRoom from "../AuctionRoomSharedContacts.bs.js";

function BidCapLearnMoreModal(props) {
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var match$1 = AuctionRoomSharedContacts$LiveRoom.getEmailAndPhoneByAuctionLocation(AuctionRoomSharedContacts$LiveRoom.getAuctionLocationType(props.location));
  var locationPhone = match$1[1];
  var locationEmail = match$1[0];
  return React.createElement(SterlingModal$LiveRoom.Modal.make, {
              children: React.createElement(SterlingModal$LiveRoom.Content.make, {
                    children: React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                          children: null
                        }, Curry._1(t, "BidCap_BidLimitHasBeenReached") + " ", React.createElement(SterlingTypography$LiveRoom.Paragraph14LinkRegular.make, {
                              href: "tel:" + Utils_String$LiveRoom.removeWhitespaces(locationPhone),
                              children: locationPhone
                            }), " " + (Curry._1(t, "Common_or_string") + " "), React.createElement(SterlingTypography$LiveRoom.Paragraph14LinkRegular.make, {
                              href: "mailto:" + locationEmail,
                              children: locationEmail
                            })),
                    className: Curry._1(Css.style, {
                          hd: Css.margin2(Css.px(8), Css.px(0)),
                          tl: /* [] */0
                        })
                  }),
              onClose: props.onClose,
              isOpen: true,
              fixHeader: true,
              headerTitle: Curry._1(t, "BidCap_BidLimitReached")
            });
}

var make = BidCapLearnMoreModal;

export {
  make ,
}
/* Css Not a pure module */
